export default __webpack_public_path__ + "ddb0b119302c5548cdcf120647984b3f.png";